import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const SECTIONS = [
  ["Acceptance of terms", "By using MAS Grading and submitting cards for certification, you agree to these terms. If you do not agree, please do not use the service."],
  ["Grading services", "Grading is a professional opinion of a card's condition based on our standards at the time of assessment. Grades are assigned in good faith by our experts and are final. Turnaround times are estimates, not guarantees."],
  ["Add-on services", "Autograph Authentication confirms whether a signature is genuine. Auto Grade assigns a grade to an authenticated autograph and requires Autograph Authentication on the same card. Add-on fees are billed per card."],
  ["Submissions & payment", "You are responsible for accurately declaring each card's value and details. Payment is due at checkout and processed by Stripe. Fees are based on your selected tier, declared value, and any add-on services."],
  ["Shipping & risk", "You are responsible for packaging and shipping cards to us securely. MAS is not liable for loss or damage occurring in transit to our facility. We insure return shipments up to declared value where applicable."],
  ["Liability", "To the maximum extent permitted by law, MAS's total liability for any claim relating to a submission is limited to the card's declared value or the fees paid for that submission, whichever is lower."],
  ["Certification integrity", "Tampering with, altering, or reproducing a MAS slab or certificate voids the certification and is prohibited. Population data is provided for reference and may change as more cards are graded."],
  ["Contact", "Questions about these terms? Email support@mascertified.com."],
];

export default function Terms() {
  return (
    <div className="bg-white" data-testid="terms-page">
      <Seo title="Terms of Service" description="The terms that govern your use of MAS Grading." path="/terms" />
      <PageHeader eyebrow="Legal" title="Terms of Service" subtitle="The terms that govern your use of MAS Grading." />
      <section className="max-w-3xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <p className="text-neutral-400 text-sm mb-10">Last updated: June 2026</p>
        <div className="space-y-10">
          {SECTIONS.map(([t, d]) => (
            <div key={t}>
              <h2 className="font-display font-extrabold text-2xl tracking-tight text-[#0A0A0A]">{t}</h2>
              <p className="text-neutral-500 mt-3 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
